import {Injector} from '@angular/core';
//@dynamic
export class ActionsInjector {
  static injector?: Injector;
}
